module.exports = __webpack_public_path__ + "static/use-case-5-content-7-a-e156be015e57b7f4e9235407c67d8246.png";